import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MediaAttachmentComponent } from '@klickdata/core/media/src/media-attachment/media-attachment.component';
import { Media } from '@klickdata/core/media/src/media.model';

@Component({
    selector: 'app-menu-side-media-upload-file',
    templateUrl: './menu-side-media-upload-file.component.html',
    styleUrls: ['./menu-side-media-upload-file.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuSideMediaUploadFileComponent {
    @ViewChild('uploader') uploader: MediaAttachmentComponent;
    @Output() saving: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output() onMediaReady: EventEmitter<Media> = new EventEmitter<Media>();
    constructor() {}

    onUploadComplete(mediaItems: Media[]) {
        this.onMediaReady.emit(mediaItems[0]);
    }
}
